// UnitTree — flattens the org hierarchy BENEATH the company root into indented
// rows (the root itself renders separately as a static CompanyNode). A node's
// children render only when it is expanded.

import { type ReactNode } from 'react';
import UnitRow from './UnitRow';
import { type OrgUnit } from '@/mocks/structure';

interface UnitTreeProps {
  root: OrgUnit;
  expandedIds: Set<string>;
  selectedId: string | null;
  onToggle: (id: string) => void;
  onSelect: (id: string) => void;
}

const UnitTree = ({ root, expandedIds, selectedId, onToggle, onSelect }: UnitTreeProps) => {
  const render = (units: OrgUnit[], depth: number): ReactNode[] =>
    units.flatMap((unit) => {
      const expanded = expandedIds.has(unit.id);
      const rows: ReactNode[] = [
        <UnitRow
          key={unit.id}
          unit={unit}
          depth={depth}
          expanded={expanded}
          selected={selectedId === unit.id}
          onToggle={onToggle}
          onSelect={onSelect}
        />,
      ];
      if (unit.children?.length && expanded) {
        rows.push(...render(unit.children, depth + 1));
      }
      return rows;
    });

  // Render the units beneath the root; the root is a static CompanyNode.
  return <div className='structure-tree'>{render(root.children ?? [], 0)}</div>;
};

export default UnitTree;
